import { SHAPE_STROKE_PROPS } from './stroke-props';

interface EllipseProps {
  strokeDasharray: string | undefined;
}

export default function Ellipse({ strokeDasharray }: EllipseProps) {
  return (
    <ellipse
      cx={50} cy={50}
      rx={50} ry={50}
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
